export function toCurrencyFormat(value) {
    if( Number.isInteger(value) ) {
        return value.toLocaleString();
    }
    return value;
}